import { request } from "./request";


export default {
  /**
   * 身份验证
   * @param {*} username 
   * @returns 
   */
  getAccessToken (username) {
    return request({
      url: "/auth/getAccessToken",
      method: "get",
      params: {
        username
      }
    })
  },
  /**
   * 验证Token是否有效
   * @returns 
   */
  checkValidToken () {
    return request({
      url: "/auth/checkValidToken",
      method: "get",
      params: {
        AuthKey: process.env.VUE_APP_VERSION
      }
    })
  },

  /**
   * 登录请求
   * @param {*} LoginName 
   * @param {*} LoginPassword 
   * @returns 
   */
  login (username, password, AuthKey) {
    return request({
      url: "/login",
      method: "post",
      params: {
        username,
        password,
        AuthKey
      }
    })
  }
}
